import { defineComponent, computed, provide } from '@vue/composition-api';
import { getUid } from '@/util/common';
import { formElementProps } from '@/components/Inputs/_components/FormElement/form-element.constants';
export default defineComponent({
    name: 'FormElement',
    props: {
        ...formElementProps,
    },
    setup(props) {
        const isError = computed(() => props.error || Boolean(props.errorMessage));
        const descriptionId = `form-desc-${getUid()}`;
        const activeDescriptionId = computed(() => !isError.value && props.description ? descriptionId : undefined);
        provide('formElementDescriptionId', activeDescriptionId);
        return { isError, descriptionId };
    },
});
